import { Component, OnInit, Input } from '@angular/core'
import { CpmService } from 'app/service/cpm.service'
import { FormControl } from '@angular/forms'
import { environment } from 'environments/environment'
import { AuthorizeService } from '../../../service/authorize.service';
import { StoreService } from '../../../service/store.service';
import { Subscription } from 'rxjs/Subscription'
import { DatePipe } from '@angular/common'
import { start } from 'repl';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-bod-info',
  templateUrl: './bod-info.component.html',
  styleUrls: ['./bod-info.component.scss']
})
export class BodInfoComponent implements OnInit {
  result = null
  isAE
  dataList
  boardProfileList
  bodProfile
  subscription: Subscription
  imageControl = new FormControl()
  bodTableOptions: DataTables.Settings = {}
  bodHeader = ['Company', 'Position', 'Start date']
  imageUrl: String = '/assets/img/avatar.png'
  displayChangeProfileImage = false
  @Input('bodId') bodId: string
  @Input('symbol') symbol: string

  constructor(
    private cpmService: CpmService,
    private authorization: AuthorizeService,
    private store: StoreService,
    private datePipe: DatePipe,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.bodTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      columnDefs: [{ targets: 2, orderData: 3 }, { targets: 3, visible: false }]
    }

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.isAE = response['ae']
      })


    this.getBodInformation()
  }

  async getBodInformation() {
    await this.cpmService
      .getBodInformation(this.bodId)
      .then(res => {
        this.result = res
        this.boardProfileList = res.board
        this.getImageUrl()
        $('#loadingInfo').hide()
      })
      .catch(() => {
        $('#loadingInfo').text('Error occurs while fetching data...')
      })

    this.dataList = []
    this.bodProfile = []
    const bodList = await this.setDataBod(this.boardProfileList)
    bodList.map(obj => {
      const bodPro = {}
      const positionStartdate = []
      const snStartdate = []
      let prevStartDate

      obj.startDate.map(startDate => {
        const dateFormat = this.datePipe.transform(startDate, 'd MMM yyyy')
        snStartdate.push(dateFormat);
        if (prevStartDate) {
          if (prevStartDate !== startDate) {
            positionStartdate.push(
              dateFormat
            )
          }
        } else {
          prevStartDate = startDate
          positionStartdate.push(
            dateFormat
          )
        }
      })

      if (positionStartdate.length !== 1) {

        bodPro['startDate'] = snStartdate.toString().split(',').join(', ')
      } else {

        bodPro['startDate'] = positionStartdate.join(', ')
      }


      bodPro['securitySymbol'] = obj.securitySymbol
      bodPro['positionNameEn'] = obj.positionNameEn.join(', ')
      this.bodProfile.push(bodPro)
    })
  }

  setDataBod(bodlist) {
    const bods = bodlist.reduce((acc, bod) => {
      const found = acc.find(x => {
        return x.securitySymbol === bod.securitySymbol
      })
      if (found) {
        found.positionNameTh.push(bod.positionNameTh)
        found.positionNameEn.push(bod.positionNameEn)
        found.startDate.push(bod.startDate)
      } else {
        const x = Object.assign({}, bod)
        x.positionNameTh = [bod.positionNameTh]
        x.positionNameEn = [bod.positionNameEn]
        x.startDate = [bod.startDate]
        acc.push(x)
      }
      return acc
    }, [])
    return bods
  }

  getImageUrl() {
    this.cpmService
      .testDownloadBod(this.bodId)
      .then(() => {
        this.imageUrl = `${
          environment.cpmBaseUrl
          }/download?type=bodprofile&id=${this.bodId}`
      })
      .catch(error => {
        this.imageUrl = '/assets/img/avatar.png'
      })
  }

  treatedData() {
    return this.bodProfile.length > 0 ? this.bodProfile : null
  }

  fileChange(event: any) {
    const reader = new FileReader()
    if (event.target.files && event.target.files.length > 0) {
      const fileName = event.target.files[0].name.split(".");
      const openableFormat = ['jpg', 'gif', 'png'];
      const arrayContainsFileType = (openableFormat.indexOf(fileName[fileName.length - 1].toLowerCase()) > -1);
      if (arrayContainsFileType) {
        const file = event.target.files[0]
        this.upload(file, 'BodProfile')
      } else {
        this.toastr.error('Selected file is not a picture.')
      }
    }
  }

  async upload(file, dataType) {
    this.imageUrl = '/assets/img/avatar.png'
    const body = new FormData()
    body.append('file', file)
    body.append('type', dataType)
    body.append('id', this.bodId)
    await this.cpmService.uploadFile(body)
    await this.getImageUrl()
  }

  get isUserHasEditPermission() {
    return (this.authorization.hasRole('COMPINFO_EDIT'));
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/bod/bod-info/bod-info.component.ts